/**
 * @generated SignedSource<<9be28c345f906c80c49959c9ee530754>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueRealtimeUpdater_project$data = {
  readonly key: string;
  readonly projectId: string;
  readonly " $fragmentType": "IssueRealtimeUpdater_project";
};
export type IssueRealtimeUpdater_project$key = {
  readonly " $data"?: IssueRealtimeUpdater_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueRealtimeUpdater_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "IssueRealtimeUpdater_project",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "projectId"
      },
      "action": "THROW",
      "path": "projectId"
    },
    {
      "kind": "ScalarField",
      "name": "key"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "a5539e715af10148bab39eda849e59a5";

export default node;
